import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px;
    background: #f4f4f4;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
    border: 1px solid ${colors.platinum};
  `,
  button: css`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 0px !important;
  `,
   optionMenu: css`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  `,
  optionText: css`
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  filterButton: css`
    padding: 2px 8px;
    border-radius: 10px;
    border: 1px solid ${colors.prussian400};
  `,
  selectedOption: css`
    background-color: ${colors.platinum} !important;
  `,
  activeOption: css`
    @media (max-width: 480px) {
      white-space: nowrap;
      max-width: 198px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `,
  popper: css`
    max-width: 262px;
    margin-top: 6px !important;
  `,
};

export default styles;
